import { I18N_UI_LANGUAGE_OPTIONS } from '../constants/uiLanguages';

export const PROFILE_TYPES = ['person', 'member', 'employee', 'adherent', 'fidele', 'other'];

export const SEX_OPTIONS = [
  { value: '', label: 'Non precise' },
  { value: 'female', label: 'Feminin' },
  { value: 'male', label: 'Masculin' },
  { value: 'other', label: 'Autre' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: '', label: 'Non precise' },
  { value: 'single', label: 'Celibataire' },
  { value: 'married', label: 'Marie(e)' },
  { value: 'divorced', label: 'Divorce(e)' },
  { value: 'widowed', label: 'Veuf(ve)' },
];

export const IDENTITY_DOC_TYPES = [
  { value: '', label: 'Non precise' },
  { value: 'national_id', label: "Carte d'identite nationale" },
  { value: 'passport', label: 'Passeport' },
  { value: 'residence_permit', label: 'Titre de sejour' },
  { value: 'driver_license', label: 'Permis de conduire' },
  { value: 'voter_card', label: "Carte d'electeur" },
  { value: 'other', label: 'Autre' },
];

/** Langue d’interface / préférence — uniquement les locales réellement internationalisées dans l’app. */
export const LANGUAGE_OPTIONS = [{ value: '', label: 'Non precisee' }, ...I18N_UI_LANGUAGE_OPTIONS];

export const ISO_COUNTRY_CODES = [
  'AF','AX','AL','DZ','AS','AD','AO','AI','AQ','AG','AR','AM','AW','AU','AT','AZ','BS','BH','BD','BB','BY','BE','BZ','BJ','BM','BT','BO','BQ','BA','BW','BV','BR','IO','BN','BG','BF','BI','CV','KH','CM','CA','KY','CF','TD','CL','CN','CX','CC','CO','KM','CG','CD','CK','CR','CI','HR','CU','CW','CY','CZ','DK','DJ','DM','DO','EC','EG','SV','GQ','ER','EE','SZ','ET','FK','FO','FJ','FI','FR','GF','PF','TF','GA','GM','GE','DE','GH','GI','GR','GL','GD','GP','GU','GT','GG','GN','GW','GY','HT','HM','VA','HN','HK','HU','IS','IN','ID','IR','IQ','IE','IM','IL','IT','JM','JP','JE','JO','KZ','KE','KI','KP','KR','KW','KG','LA','LV','LB','LS','LR','LY','LI','LT','LU','MO','MG','MW','MY','MV','ML','MT','MH','MQ','MR','MU','YT','MX','FM','MD','MC','MN','ME','MS','MA','MZ','MM','NA','NR','NP','NL','NC','NZ','NI','NE','NG','NU','NF','MK','MP','NO','OM','PK','PW','PS','PA','PG','PY','PE','PH','PN','PL','PT','PR','QA','RE','RO','RU','RW','BL','SH','KN','LC','MF','PM','VC','WS','SM','ST','SA','SN','RS','SC','SL','SG','SX','SK','SI','SB','SO','ZA','GS','SS','ES','LK','SD','SR','SJ','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TK','TO','TT','TN','TR','TM','TC','TV','UG','UA','AE','GB','US','UM','UY','UZ','VU','VE','VN','VG','VI','WF','EH','YE','ZM','ZW',
];

export const NATIONALITY_CODE_SET = new Set(ISO_COUNTRY_CODES);

export const NATIONALITY_OPTIONS = ISO_COUNTRY_CODES.map((code) => ({
  value: code,
  label: code,
}));
